module.exports = __webpack_public_path__ + "media/images/svg/jobs/businessman-white-b1ffd498d3c11fe7f332fe798f345627.svg";